import $ from 'jquery';


/* Global variables
********************************************/


/* Accordions
********************************************/

if ($('.js-accordion').length) {
	$('.js-accordion-toggle').click(function(e){
		e.preventDefault();
		var $this = $(this);
		$this.closest('.js-accordion').find('.js-accordion-container').slideToggle();
		$this.closest('.js-accordion').toggleClass('is-active');
	});
}
